/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedTaxonomyRouteImport } from './routes/_authenticated/taxonomy'
import { Route as AuthenticatedOpticalRouteImport } from './routes/_authenticated/optical'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCatalogRouteImport } from './routes/_authenticated/catalog'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
})
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
})
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
})
const AuthenticatedTaxonomyRoute = AuthenticatedTaxonomyRouteImport.update({
  id: '/taxonomy',
  path: '/taxonomy',
  getParentRoute: () => AuthenticatedRoute,
})
const AuthenticatedOpticalRoute = AuthenticatedOpticalRouteImport.update({
  id: '/optical',
  path: '/optical',
  getParentRoute: () => AuthenticatedRoute,
})
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
})
const AuthenticatedCatalogRoute = AuthenticatedCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => AuthenticatedRoute,
})

const AuthenticatedRouteChildren = {
  AuthenticatedCatalogRoute: AuthenticatedCatalogRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedOpticalRoute: AuthenticatedOpticalRoute,
  AuthenticatedTaxonomyRoute: AuthenticatedTaxonomyRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)
